// src/components/LoginModal.js

import React, { useState } from 'react';

// --- IMPORTANT: Changez ces identifiants pour quelque chose de sécurisé et unique ---
const BARISTA_USERNAME = 'grams_barista';
const BARISTA_PASSWORD = 'GramsCoffee_2025!'; // Changez ceci !

const LoginModal = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    // Vérifier les identifiants
    if (username === BARISTA_USERNAME && password === BARISTA_PASSWORD) {
      // Si la connexion réussit, on enregistre un "jeton" dans sessionStorage
      // sessionStorage est effacé quand l'onglet du navigateur est fermé.
      sessionStorage.setItem('barista_auth_token', 'LOGGED_IN');
      onLoginSuccess();
    } else {
      setError('Invalid credentials. Please try again.');
    }
  };

  return (
    <div className="login-modal-overlay">
      <div className="login-modal-content">
        <h2>Barista Access</h2>
        <p>Please log in to manage subscriptions.</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <p className="error-message">{error}</p>}
          <button type="submit" className="login-button">Log In</button>
        </form>
      </div>
    </div>
  );
};

export default LoginModal;